import {
  Button,
  FormControl,
  FormHelperText,
  FormLabel,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  useMediaQuery,
} from '@material-ui/core';
import {InteractiveFilters} from 'Agent/AgentForms/Interactive/ducks/Interactive';
import 'Agent/AgentForms/Marketing/components/SearchForm.sass';
import {StateFilter, FilterEnum} from 'Agent/AgentForms/Marketing/ducks/Marketing';
import React, {useState} from 'react';
import {useDispatch} from 'react-redux';

type SearchFormProps = {
  setIsSearchBlock: (value: boolean | ((isSearchBlock: boolean) => boolean)) => void;
  formName: string;
  filters: InteractiveFilters;
  filter: (filter: InteractiveFilters) => void;
  interactiveFormsCategories: FilterEnum[];
  interactiveFormsType: FilterEnum[];
};

const InteractiveSearchForm = ({
  setIsSearchBlock,
  formName,
  filters,
  filter,
  interactiveFormsCategories,
  interactiveFormsType,
}: SearchFormProps) => {
  const dispatch = useDispatch();
  const [markFilter, setMarkFilter] = useState(filters);

  function handleChange(event: any) {
    if (event.target.name === 'category' || event.target.name === 'type') {
      setMarkFilter({
        ...markFilter,
        [event.target.name]: {name: event.target.value, value: event.target.value, tag: 'SelectedOption'},
      });
    } else if (event.target.name === 'states') {
      setMarkFilter({
        ...markFilter,
        [event.target.name]: {
          name: event.target.value === 'all' ? 'All States' : event.target.value,
          value: event.target.value === 'all' ? '' : event.target.value,
          tag: 'SelectedOption',
        },
      });
    } else {
      setMarkFilter({...markFilter, [event.target.name]: event.target.value});
    }
  }

  const handleClose = () => {
    setIsSearchBlock(false);
  };

  const handleSubmit = () => {
    setIsSearchBlock(false);
    if (markFilter !== filters) {
      dispatch(filter({...markFilter}));
    }
  };

  const isDesktop = useMediaQuery((theme: any) => theme.breakpoints.up('lg'));

  const handleMobile = () => {
    return isDesktop ? 'search-form-desktop-view' : 'card-filter-overlay slideIn';
  };

  return (
    <div className={handleMobile()}>
      <div className="drawer-sections">
        <div className="dropdown-section">
          <FormControl component="fieldset" className="drawer-title">
            <div className="form-control-label">
              <FormLabel id="marketing-forms-drawer-title" component="legend" className="form-drawer-label">
                {formName}
              </FormLabel>
              <span className="close-button" onClick={handleClose}>
                <i className="fa fa-times" aria-hidden="true" />
              </span>
            </div>
          </FormControl>
          <FormControl className="field-section-body">
            <InputLabel variant="standard" htmlFor="uncontrolled-native">
              Select States
            </InputLabel>
            <Select
              onChange={e => handleChange(e)}
              name="states"
              value={
                markFilter.states?.tag === 'SelectedOption'
                  ? markFilter.states?.value !== ''
                    ? markFilter.states.value.toString()
                    : 'all'
                  : ''
              }
              inputProps={{
                name: 'states',
                id: 'uncontrolled-native',
              }}
            >
              <MenuItem value="" disabled selected>
                Select State
              </MenuItem>
              {StateFilter.map(state => (
                <MenuItem key={state.value} value={state.value}>
                  {state.value}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl className="field-section-body">
            <InputLabel variant="standard" htmlFor="uncontrolled-native">
              Select Category
            </InputLabel>
            <Select
              onChange={e => handleChange(e)}
              name="category"
              value={markFilter.category.tag === 'SelectedOption' ? markFilter.category.value.toString() : ''}
              inputProps={{
                name: 'category',
                id: 'uncontrolled-native',
              }}
            >
              <MenuItem value="" disabled selected>
                Select Category
              </MenuItem>
              {interactiveFormsCategories.map(product => (
                <MenuItem key={product.name} value={product.value}>
                  {product.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl className="field-section-body">
            <InputLabel variant="standard" htmlFor="uncontrolled-native">
              Search Type
            </InputLabel>
            <Select
              onChange={e => handleChange(e)}
              name="type"
              value={markFilter.type.tag === 'SelectedOption' ? markFilter.type.value.toString() : ''}
              inputProps={{
                name: 'type',
                id: 'uncontrolled-native',
              }}
            >
              <MenuItem value="" disabled selected>
                Select Type
              </MenuItem>
              {interactiveFormsType.map(product => (
                <MenuItem key={product.name} value={product.value}>
                  {product.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl className="field-section-last">
            <TextField
              style={{cursor: 'pointer'}}
              placeholder="Search by Form Number"
              label="Search by Form Number"
              name="formNumber"
              onChange={e => handleChange(e)}
              value={markFilter.formNumber}
            />
            <FormHelperText id="component-helper-text">i.e. AWD900 or AWDINDAPP</FormHelperText>
          </FormControl>
        </div>
      </div>

      <div className="button-section">
        <Button id="submit-id-btn" variant="contained" color="primary" className="btn-submit" onClick={handleSubmit}>
          Submit
        </Button>
        <Button
          id="cancel-id-btn"
          className="btn-submit search-form-shadow"
          variant="contained"
          color="default"
          onClick={handleClose}
        >
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default InteractiveSearchForm;
